import actions from '../constants/actionTypes';

export function openDialogGeneric(page, itemId) {
  return {
    type: actions.OPEN_DIALOG_GENERIC,
    page,
    response: {
      itemId,
    },
  };
}

export function closeDialogGeneric(page) {
  return {
    type: actions.CLOSE_DIALOG_GENERIC,
    page,
  };
}

export function changeTablePageSize(page, pageSize) {
  return {
    type: actions.CHANGE_TABLE_PAGE_SIZE,
    page,
    response: {
      pageSize,
    },
  };
}

export function changeTableActivePage(page, activePage) {
  return {
    type: actions.CHANGE_TABLE_ACTIVE_PAGE,
    page,
    response: {
      activePage,
    },
  };
}

export function selectTableItem(page, selectedId, isForce = false) {
  return {
    type: actions.SELECT_TABLE_ITEM,
    page,
    response: {
      selectedId,
      isForce,
    },
  };
}

export function changeFilters(page, name, value) {
  return {
    type: actions.CHANGE_FILTER_GENERIC,
    page,
    response: {
      [name]: value,
    },
  };
}



// WEBPACK FOOTER //
// ./foody/src/redux/genericAction.js